const uz = {
  pleaseEnterUsername: "Iltimos, foydalanuvchi nomini kiriting",
  cannotFriendYourself: "O'zingizga do'stlik so'rovi yubora olmaysiz.",
  friendRequestSent: "Do'stlik so'rovi yuborildi!",
  failedToSendRequest: "So'rovni yuborib bo'lmadi",
  linkCopied: "Havola almashish buferiga nusxalandi!",
  backToInvites: "Takliflarga qaytish",
  sendFriendRequestByUsername: "Foydalanuvchi nomi orqali do'stlik so'rovi yuborish",
  enterUsername: "Foydalanuvchi nomini kiriting",
  send: "Yuborish",
  yourInviteQrCode: "Sizning taklif QR kodingiz",
  inviteLink: "Taklif havolasi",
  scanQrOrUseLink: "Do'stlik so'rovi yuborish uchun ushbu QR kodni skanerlang yoki ushbu havoladan foydalaning",
  copyInviteLink: "Taklif havolasini nusxalash",
  goToItem: "Elementga o'tish",
  verificationEmailSent: "Tasdiqlash xati yuborildi! Kiruvchi xabarlaringizni tekshiring.",
  verificationEmailFailed: "Tasdiqlash xatini yuborib bo'lmadi. Qayta urinib ko'ring.",
  verifyYourEmail: "Elektron pochtangizni tasdiqlang",
  verifyEmailInstructions: "Hisobingizga kirish uchun elektron pochta manzilingizni tasdiqlang. Tasdiqlash havolasini topish uchun kiruvchi xatlarni tekshiring.",
  sending: "Yuborilmoqda...",
  resendVerificationEmail: "Tasdiqlash xatini qayta yuborish",
  login: "Kirish",
  register: "Ro'yxatdan o'tish",
  home: "Bosh sahifa",
  calendar: "Taqvim",
  friends: "Do'stlar",
  profile: "Profil",
  logout: "Chiqish",
  loading: "Yuklanmoqda...",
  language: "Til",
  calendarSelectPlaceSuggestion: "Koordinatalarni biriktirish uchun tavsiyalardan joy tanlang.",
  calendarSelectDateAndTime: "Sana va vaqtni tanlang.",
  calendarPositiveDuration: "Musbat davomiylik kiriting.",
  calendarFutureDateRequired: "Tadbir sanasi va vaqti kelajakda bo'lishi kerak.",
  calendarCreateEventFailed: "Tadbir yaratib bo'lmadi. Qayta urinib ko'ring.",
  cancel: "Bekor qilish",
  createNewEvent: "Yangi tadbir yaratish",
  week: "Hafta",
  month: "Oy",
  eventTitle: "Sarlavha",
  date: "Sana",
  time: "Vaqt",
  duration: "Davomiyligi",
  endsAt: "Tugash vaqti",
  place: "Joy",
  searchForPlace: "Joy qidirish",
  placeSearchTip: "Maslahat: yozishni boshlang va koordinatalarni biriktirish uchun natijani tanlang.",
  description: "Tavsif",
  createEvent: "Tadbir yaratish",
  today: "Bugun",
  previousMonth: "Oldingi oy",
  nextMonth: "Keyingi oy",
  previous: "Oldingi",
  next: "Keyingi",
  mondayShort: "Du",
  tuesdayShort: "Se",
  wednesdayShort: "Cho",
  thursdayShort: "Pa",
  fridayShort: "Ju",
  saturdayShort: "Sha",
  sundayShort: "Ya",
  more: "ko'proq",
  mustRespondWillBeforeReposting: "Qayta ulashishdan oldin \"Qatnashaman\" deb javob berishingiz kerak",
  event: "Tadbir",
  backToCalendar: "Taqvimga qaytish",
  addToGoogleCalendar: "Google Taqvimga qo'shish",
  when: "Qachon",
  where: "Qayerda",
  openLocationInGoogleMaps: "Joylashuvni Google Xaritalarda ochish",
  hosts: "Tashkilotchilar",
  yourResponse: "Sizning javobingiz",
  currentResponse: "Joriy javob",
  response_will: "Qatnashaman",
  response_might: "Balki qatnasharman",
  response_wont: "Qatnashmayman",
  willRunIntoYou: "Kirib o'taman",
  mightDropBy: "Balki kirarman",
  wontCome: "Kelmayman",
  repostToMyFriends: "Do'stlarim bilan qayta ulashish",
  responses: "Javoblar",
  willAttend: "Qatnashadi",
  reposted: "Qayta ulashildi",
  mightAttend: "Balki qatnashadi",
  cancelEvent: "Tadbirni bekor qilish",
  cancellationEmailNoticeBefore: "Kelishini tasdiqlagan ishtirokchilar",
  cancellationEmailNoticeAfter: "bekor qilinganligi haqida elektron xabar olishadi.",
  optionalCancellationMessage: "Ishtirokchilarga ixtiyoriy xabar (maksimal 1000 belgi)",
  confirmCancelEvent: "Tadbir bekor qilinishini tasdiqlash",
  clear: "Tozalash",
  confirmCancellation: "Bekor qilishni tasdiqlash",
  confirmCancellationMessage: "Ushbu tadbirni bekor qilmoqchimisiz? Bu tasdiqlangan ishtirokchilarga xabar yuboradi va tadbirni o'chiradi.",
  eventCancelledNotified: "Tadbir bekor qilindi. Xabardor qilinganlar:",
  attendees: "ishtirokchilar",
  failedToCancelEvent: "Tadbirni bekor qilib bo'lmadi",
  back: "Orqaga",
  cancelled: "Bekor qilingan",
  ok: "OK",
  forgotPassword: "Parolni unutdingizmi",
  email: "Elektron pochta",
  passwordResetLinkSent: "Agar hisob mavjud bo'lsa, parolni tiklash havolasi yuborildi.",
  passwordResetRequestFailed: "Parolni tiklash so'rovi muvaffaqiyatsiz tugadi.",
  sendResetLink: "Tiklash havolasini yuborish",
  addFriend: "Do'st qo'shish",
  incomingRequests: "Kiruvchi so'rovlar",
  accept: "Qabul qilish",
  deny: "Rad etish",
  myFriends: "Mening do'stlarim",
  noFriendsYet: "Hali do'stlaringiz yo'q. Qo'shishni boshlang!",
  seeProfile: "Profilni ko'rish",
  noEventsToRespondTo: "Javob beriladigan tadbirlar yo'q",
  allCaughtUp: "Hammasi ko'rib chiqildi. Do'stlaringizning yangi tadbirlarini keyinroq tekshiring.",
  events: "Tadbirlar",
  unknown: "Noma'lum",
  noDescriptionProvided: "Tavsif berilmagan.",
  will: "Ha",
  maybe: "Balki",
  wont: "Yo'q",
  userNotFound: "Foydalanuvchi topilmadi",
  friendRequestSentSuccessfully: "Do'stlik so'rovi muvaffaqiyatli yuborildi!",
  friendInvitation: "Do'stlik taklifi",
  sendFriendRequest: "Do'stlik so'rovi yuborish",
  loginToSendFriendRequest: "Do'stlik so'rovi yuborish uchun tizimga kiring",
  chooseLanguage: "Tilni tanlang",
  invalidCredentials: "Noto'g'ri kirish ma'lumotlari. Qayta urinib ko'ring.",
  username: "Foydalanuvchi nomi",
  password: "Parol",
  forgotPasswordQuestion: "Parolni unutdingizmi?",
  dontHaveAccount: "Hisobingiz yo'qmi?",
  registerHere: "Bu yerda ro'yxatdan o'ting",
  invalidProfilePhotoType: "Noto'g'ri fayl turi. JPEG, PNG, GIF yoki WebP rasm yuklang.",
  invalidFileExtension: "Noto'g'ri fayl kengaytmasi",
  allowedExtensions: "Ruxsat etilgan",
  fileTooLarge: "Fayl juda katta",
  maximumFileSize: "Maksimum",
  profilePhotoRemoved: "Profil rasmi olib tashlandi.",
  failedToRemoveProfilePhoto: "Profil rasmini olib tashlab bo'lmadi",
  profileUpdatedSuccessfully: "Profil muvaffaqiyatli yangilandi!",
  failedToUpdateProfile: "Profilni yangilab bo'lmadi",
  privateEmailExplanation: "Platformadan tashqaridagi istalmagan xabarlarning oldini olish uchun elektron pochta manzilingizni faqat siz ko'rasiz",
  yourEmailIsPrivate: "Elektron pochtangiz maxfiy.",
  profilePhoto: "Profil rasmi",
  removePhoto: "Rasmni olib tashlash",
  firstName: "Ism",
  lastName: "Familiya",
  tellPeopleAboutYourself: "O'zingiz haqingizda gapirib bering",
  whereToContactMe: "Menga qanday bog'lanish mumkin",
  contactInfoPlaceholder: "Instagram: myUsername\nDiscord: myDiscord",
  save: "Saqlash",
  notSet: "O'rnatilmagan",
  editProfile: "Profilni tahrirlash",
  imageToCrop: "Kesiladigan rasm",
  zoom: "Kattalashtirish",
  usePhoto: "Rasmdan foydalanish",
  name: "Ism",
  whereToContact: "Aloqa ma'lumotlari",
  removeFriendship: "Do'stlikni olib tashlash",
  confirmRemoveFriend: "Do'stni olib tashlashni tasdiqlash",
  confirmRemoveFriendBefore: "",
  confirmRemoveFriendAfter: "ni do'stlar ro'yxatingizdan olib tashlamoqchimisiz?",
  friendRemoved: "Do'st olib tashlandi.",
  failedToRemoveFriend: "Do'stni olib tashlab bo'lmadi.",
  confirmRemove: "Olib tashlashni tasdiqlash",
  error: "Xato",
  removed: "Olib tashlandi",
  passwordsDoNotMatch: "Parollar mos kelmaydi",
  registrationFailed: "Ro'yxatdan o'tish muvaffaqiyatsiz tugadi. Qayta urinib ko'ring.",
  confirmPassword: "Parolni tasdiqlash",
  alreadyHaveAccount: "Hisobingiz bormi?",
  loginHere: "Bu yerda kiring",
  passwordResetSuccessfully: "Parol muvaffaqiyatli tiklandi.",
  failedToResetPassword: "Parolni tiklab bo'lmadi.",
  resetPassword: "Parolni tiklash",
  newPassword: "Yangi parol",
  confirmNewPassword: "Yangi parolni tasdiqlash",
  setNewPassword: "Yangi parolni o'rnatish",
  emailVerifiedSuccessfully: "Elektron pochta muvaffaqiyatli tasdiqlandi!",
  emailVerificationFailed: "Tasdiqlash muvaffaqiyatsiz tugadi. Havola yaroqsiz yoki muddati tugagan bo'lishi mumkin.",
  verifying: "Tasdiqlanmoqda...",
  verified: "Tasdiqlandi!",
  redirectingToHome: "Bosh sahifaga yo'naltirilmoqda...",
  verificationFailed: "Tasdiqlash muvaffaqiyatsiz tugadi",
  goToHome: "Bosh sahifaga o'tish",
  about: "Haqida",
  aboutConceptTitle: "G‘oya",
  aboutCreatorIntroduction: "Salom, men Crypt0, qoyaga tirmashuvchi va Run Into Me yaratuvchisiman.",
  aboutCreatorStory: "Bu saytni odamlar bilan muloqot qilishni yoqtirganim va uchrashuvlarni rejalashga juda ko‘p vaqt sarflaganim uchun yaratdim.",
  aboutPlanningProblem: "Rasmiy taklifsiz qachon va qayerda tirmashishimni hammaga bir vaqtda bildirmoqchi edim.",
  aboutDeveloperSolution: "Shunda dasturchi ekanimni va yechimni o‘zim yarata olishimni esladim.",
  aboutWelcome: "Do‘stlaringizga bosimsiz qo‘shilishlari mumkin bo‘lgan mashg‘ulotlarni ko‘rsatadigan Run Into Me xizmatiga xush kelibsiz.",
  aboutCallToAction: "Birgalikda qiziqroq bo‘lgan keyingi mashg‘ulotni shu yerda e’lon qiling!",
  aboutTutorialTitle: "Qo‘llanma",
  aboutCalendarCreateEvent: "Taqvim ekranida yangi tadbir ham yaratishingiz mumkin.",
  aboutEventColorsIntroduction: "Ranglar ishtirok holatini ko‘rsatadi:",
  aboutColorGold: "Oltin",
  aboutColorGoldDescription: "Tadbirga siz mezbonlik qilasiz.",
  aboutColorGreen: "Yashil",
  aboutColorGreenDescription: "Tadbirda qatnashasiz.",
  aboutColorOrange: "To‘q sariq",
  aboutColorOrangeDescription: "“Balki” deb javob berdingiz.",
  aboutColorBlue: "Ko‘k",
  aboutColorBlueDescription: "Hali javob bermadingiz.",
  aboutColorGray: "Kulrang",
  aboutColorGrayDescription: "Taklifni rad etdingiz.",
  aboutCalendarEventDetails: "Tafsilot va javob uchun tadbirni bosing.",
  aboutFriendPageTitle: "Do‘stlar sahifasi",
  aboutFriendPageDescription: "Foydalanuvchi nomini kiriting yoki havola / QR kod yuboring.",
  aboutHomePageTitle: "Bosh sahifa",
  aboutHomePageDescription: "Tadbirlarni ko‘ring va qatnashishingizni bildiring.",
  aboutRepostScreenTitle: "Qayta ulashish ekrani",
  aboutGoogleCalendarDescription: "Tadbirni Google Taqvimga shu tugma bilan qo‘shing.",
  aboutRepostDescription: "Tasdiqlagach, tadbirni do‘stlaringizga qayta ulashing.",
};

export default uz;